exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*  DATATABLES */\r\ntable.dataTable {\r\n    border-collapse: collapse !important;\r\n}\r\n\r\ntable.dataTable.dtr-inline.collapsed > tbody > tr > td:first-child:before,\r\ntable.dataTable.dtr-inline.collapsed > tbody > tr > th:first-child:before {\r\n    line-height: 18px !important;\r\n}\r\n\r\n.container-fluid.dt-bootstrap4 {\r\n    padding: 0;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null],"sourceMap":false}!./src/assets/modules/vendors/datatables/datatables.css
// module id = ./node_modules/css-loader/index.js?{"sourceMap":false,"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null,null],"sourceMap":false}!./src/assets/modules/vendors/datatables/datatables.css
// module chunks = styles